<template>
    <div class="row">
        <FormGroup :label="$t('labels.domain')" class="col-lg-12">
            <Input v-model="domain" placeholder="https://example.com"/>
        </FormGroup>
        <FormGroup :label="$t('labels.consumer_key')" class="col-lg-6">
            <Input v-model="login"/>
        </FormGroup>
        <FormGroup :label="$t('labels.consumer_secret')" class="col-lg-6">
            <Input v-model="password" type="password"/>
        </FormGroup>
    </div>
</template>
<script>
import FormGroup from '../../../../../components/new/form/group/FormGroup.vue';
import Input from '../../../../../components/new/form/Input.vue';

import { normalizeDomain } from './normalizeDomain';

export default {
    name: "WoocommerceCredentialFields",
    components: {
        FormGroup, Input
    },
    props: {
        credential: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            domain: this.credential?.domain ?? '',
            login: this.credential?.login ?? '',
            password: this.credential?.password ?? ''
        };
    },
    methods: {
        buildRequest() {
            let request = {
                domain: normalizeDomain(this.domain),
                login: this.login,
                password: this.password
            };

            return request;
        }
    }
}
</script>
